module.exports = __webpack_public_path__ + "img/contenttemplate.6af1a42a.svg";